import { styled } from "@mui/system"

export const Icon = styled("i")({
  marginLeft: "0px !important",
  color: "#3b4edf !important",
  fontSize: 12,
})